module.exports = __webpack_public_path__ + "img/jackpot-bg_960.3e1ba3e1.png";